<template>
    <div class='flex h-full qk-sxpris-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
                @toolbar-button-click="onToolbarClickTree"
                @insert-save="insertSave"
                @user-data-changed='onUserDataChanged'
                @treeListEditMounted="treeListEditMounted"
                @changesSavedSuccessfully="changesSavedSuccessfully"
                @refreshEnd="onRefreshEnd"
            >
            </ai-tree-list-edit>
        </div>
        <div class='h-full flex flex-col w-full'>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>Наименование</div>
                <div class="tep-header-input">
                    <ai-text-box
                        :value='nameTree'
                        @input='(data) => onTreeDataChange("name", data.newText)'
                    ></ai-text-box>
                </div>
            </div>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>Теплоноситель</div>
                <div class="tep-header-input">
                    <tep-lookup
                        :value='tnTree'
                        :meta='selectMeta.tn'
                        :data-source='lookupTnList'
                        @selected-value='(value) => onTreeDataChange("kod_tn", value)'
                    ></tep-lookup>
                </div>
            </div>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>Присоединение</div>
                <div class="tep-header-input">
                    <tep-lookup
                        :value='sxprTree'
                        :meta='selectMeta.sxpr'
                        :data-source='lookupSxprList'
                        @selected-value='(value) => onTreeDataChange("kod_tip_sxpr", value)'
                    ></tep-lookup>
                </div>
            </div>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>Рециркуляция</div>
                <div class="tep-header-input">
                    <tep-lookup
                        :value='rcircTree'
                        :meta='selectMeta.rcirc'
                        :data-source='lookupRcircList'
                        @selected-value='(value) => onTreeDataChange("kod_tip_rcirc", value)'
                    ></tep-lookup>
                </div>
            </div>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>КПД (%)</div>
                <div class="tep-header-input">
                    <ai-number-box
                        :value='kpdTree'
                        @input='(data) => onTreeDataChange("kpd", data.newText)'
                    ></ai-number-box>
                </div>
            </div>
            <div class='tep-header-item w-full flex dx-field'>
                <div class='tep-header-label'>Выбор разрешен</div>
                <div class="tep-header-input">
                    <dx-check-box
                        v-model:value="checkboxTree"
                        iconSize="18"
                        class="custom-checkbox"
                        @valueChanged="valueChanged"
                     ></dx-check-box>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'qk-sxpris-view',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import DxCheckBox from 'devextreme-vue/check-box';
import tepService from '@/service/tep-service';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import AiTextBox from '@/components/ai-text-box.vue';
import AiNumberBox from '@/components/ai-number-box.vue';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';


const treeRef = ref(null);
const selectedKod = ref(null);
const lookupTnList = ref(null);
const lookupSxprList = ref(null);
const lookupRcircList = ref(null);
const nameTree = ref(null);
const kpdTree = ref(null);
const tnTree = ref(null);
const sxprTree = ref(null);
const rcircTree = ref(null);
const dataTree = ref(null);
const treeInstance = ref(null);
const btnToolbar = ref(null);

onMounted(async() => {
    await treeRef.value?.setDataSource();
    await onStart();
});

const onStart = async (keySelect = null) => {
    let keySelectTreeFocus = keySelect;
    dataTree.value = await treeRef.value?.getTreeListDataSource();
    if(!keySelectTreeFocus) {
        keySelectTreeFocus = dataTree.value?.length ? dataTree.value[0].kod_sxpris : null;
    }
    selectedKod.value = keySelectTreeFocus;
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);
    await getLookupsData();
    await getNameFields();
};

const treeListEditMounted = async () => {
    treeInstance.value = treeRef?.value.treeListInstance;
};

const getLookupsData = async () => {
    lookupTnList.value = await  tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-uu-tepn/select/get', {});
    lookupSxprList.value = await tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-uu-tip-sxpr/select/get', {});
    lookupRcircList.value = await tepService.getLookupsQkSxpris('tep-nsi./tep-nsi/lookup-uu-tip-rcirc/select/get', {});
};

const getNameFields = async () => {
    nameTree.value = await treeValue('name');
    tnTree.value =await  treeValue('kod_tn');
    sxprTree.value = await treeValue('kod_tip_sxpr');
    rcircTree.value =await  treeValue('kod_tip_rcirc');
    kpdTree.value = await treeValue('kpd');
};

const clearNameFields = () => {
    nameTree.value = null;
    tnTree.value = null;
    kpdTree.value = 0;
}

const checkboxTree = computed(() => {
    const rowData = dataTree.value?.find(el => el.kod_sxpris === selectedKod.value);
    return rowData ? rowData['pr_choice'] : null
});

const treeValue = (field) => {
    const rowData = dataTree.value?.find(el => el.kod_sxpris === selectedKod.value);
    return rowData ? rowData[field] : null
};

const onTreeCellClick = async (event, newEl = false) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    if( !buttonsRefs.value['isSaveButtonDisabled']  && !newEl && selectedKod.value !== event.key) {
       const checkT = await checkTree();
       if(!checkT) return;
    }
    selectedKod.value = event.key;
    await buttonsStateChangeDisabled(false);
    await getNameFields();
};

const checkTree = async () => {
    await treeRef.value.treeListInstance.clearSelection();
    let canClose = await treeRef.value?.checkBeforeClose();
    return canClose;
};

const onToolbarClickTree = async(event) => {
    const name = event?.item?.component?.name
    btnToolbar.value = name;
};

const changesSavedSuccessfully = async() => {
    if(btnToolbar.value === 'delete') {
        await onStart();
    }
    btnToolbar.value = null;
}

const onTreeDataChange = async(field, textData) => {
    if(field === 'kod_tn') tnTree.value = textData;
    if(field === 'kod_tip_sxpr') sxprTree.value = textData;
    if(field === 'kod_tip_rcirc') rcircTree.value = textData;
    const instance = await treeRef.value?.treeListInstance;
    if (!instance) return;
    const focusedRowKey = await instance.option('focusedRowKey');
    if (focusedRowKey != null) {
        const focusedRowIndex = instance.getRowIndexByKey(focusedRowKey);
        instance.cellValue(focusedRowIndex, field, textData);
        await buttonsStateChangeDisabled(true)
    }
};

const valueChanged = e => {
    if(checkboxTree.value === e.value) return;
    onTreeDataChange('pr_choice', e.value);
};

const buttonsStateChangeDisabled = async (status) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    buttonsRefs.value['isAddChildButtonDisabled'] = status;
    buttonsRefs.value['isAddSiblingButtonDisabled'] = status;
    buttonsRefs.value['isDeleteButtonDisabled'] = status;
};

const insertSave = async (insert) => {
    if(insert?.responses?.length) {
        await buttonsStateChangeDisabled(false);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        if(insert?.responses[0].id) {
            selectedKod.value = insert?.responses[0].id;
            await onStart(selectedKod.value);
        }
    }
};

const onUserDataChanged = async (userData) => {
    const insertData = userData.treeListChanges?.filter(el => el.type === 'insert') ?? [];
    if(insertData?.length) {
        const itemNew = insertData[0];
        await onTreeCellClick(itemNew, true)
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        await treeRef.value?.treeListInstance.option('focusedRowKey', itemNew.key);
    }
};

const onRefreshEnd = async () => {
    if(btnToolbar.value === 'refresh') {
        clearNameFields();
        await treeRef.value?.setFocusdRow(selectedKod.value);
        await onStart(selectedKod.value);
    }
}


const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];

const treeMeta = {
    "keyExpr": "kod_sxpris",
    "columns": [
        {
            "name": "kod_sxpris",
            "caption": "kod_sxpris",
            "dataField": "kod_sxpris",
            "allowEditing": false,
            "width": 250,
            "index": 1,
            "visible": false
        },
        {
            "name": "kod_r",
            "caption": "kod_r",
            "dataField": "kod_r",
            "allowEditing": false,
            "width": 250,
            "index": 2,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Наименование",
            "dataField": "name",
            "allowEditing": false,
            "width": '100%',
            "index": 3,
            "visible": true
        },
        {
            "name": "kod_tn",
            "caption": "Теплоноситель",
            "dataField": "kod_tn",
            "allowEditing": false,
            "width": 250,
            "index": 4,
            "visible": false
        },
        {
            "name": "kod_tip_sxpr",
            "caption": "Присоединение",
            "dataField": "kod_tip_sxpr",
            "allowEditing": false,
            "width": 250,
            "index": 5,
            "visible": false
        },
        {
            "name": "kod_tip_rcirc",
            "caption": "Рециркуляция",
            "dataField": "kod_tip_rcirc",
            "allowEditing": false,
            "width": 250,
            "index": 6,
            "visible": false
        },        {
            "name": "kpd",
            "caption": "КПД (%)",
            "dataField": "kpd",
            "allowEditing": false,
            "width": 250,
            "index": 7,
            "visible": false
        },        {
            "name": "pr_choice",
            "caption": "Выбор разрешен",
            "dataField": "pr_choice",
            "allowEditing": false,
            "width": 250,
            "index": 8,
            "visible": false
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/qk-sxpris/select/get",
        "save": "tep-nsi./tep-nsi/qk-sxpris/save/set"
    },
    "viewId": "view-qk-sxpris",
    "parentIdExpr": "kod_r",
    'findTool': 'filter',
    'selectButtonMode': 'single',
    'selectionMode': 'single',
    'maxWidth': 'w-full',
    'wordWrapEnabled': true,
    'allowColumnResizing': false,
};

const selectMeta = {
    'tn': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-uu-tepn/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-q-uu-tepn"
    },
    'sxpr': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-uu-tip-sxpr/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-q-uu-tip-sxpr"
    },
    'rcirc': {
        title: '',
        keyExpr: 'kod',
        api: {select: 'tep-nsi./tep-nsi/lookup-uu-tip-rcirc/select/get'},
        wordWrapEnabled: true,
        fieldNameText: "name",
        fieldNameId: "kod",
        hasntRoute: true,
        columns: [
            {
                caption: '',
                name: 'kod',
                dataField: 'kod',
                visible: false,
                width: 50,
                index: 1,
            },
            {
                caption: '',
                name: 'name',
                dataField: 'name',
                visible: true,
                index: 2,
                allowFiltering: false
            },
        ],
        viewId: "lookup-q-uu-tip-rcirc"
    }
};
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 500px;
    margin-right: 20px;
}

.tep-header-item {
    align-items: center;
}

.tep-header-label {
    width: 120px;
    padding-right: 8px;
    text-align: right;
}

.tep-header-input {
    width: 600px;
}

:root .tep-header-input :deep(.dx-field-value) {
    width: 100%;
}
</style>
